// ArticleCard.tsx
import React from "react";
import Link from "@/components/Link";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import {
  analyticsClickEventAfterSearch,
  analyticsClickEventBeforeSearch,
} from "@/services/algolia/analytics";
import { algoliaConfig } from "@/services/algolia/config";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import { Button } from "@dxp-feed/ui";
import ImageWrapper from "@/components/ImageWrapper";
import { RecipeImage } from "@/utils/constant";
import { CheckIfRecordIsPreferred } from "@/helpers/useCommonFunctions";


const ArticleCard: React.FC<any> = ({
  data,
  searchQuery = "",
  isSearchPage = false,
}) => {
  const userSession = useAppSelector((state) => state.gigyaslice);
  const { buttonText } = useAppSelector((state) => state.AemArticledataSlice);
  const userId = userSession?.uid ?? undefined;

  // Ensure pageSlug is being set correctly
  const articleLink = `/articles/${data.pageSlug || data.objectID}`;

  const articleClickHandler = (event: React.MouseEvent) => {
    if (searchQuery?.length) {
      analyticsClickEventAfterSearch({
        kind: "articles",
        index: algoliaConfig.indexNames.articles,
        objectIDs: [String(data?.objectID)],
        userToken: userId,
        positions: [data.__position!],
        queryID: String(data.__queryID),
      });
    } else {
      analyticsClickEventBeforeSearch({
        kind: "articles",
        index: algoliaConfig.indexNames.articles,
        objectIDs: [String(data.objectID)],
        userToken: userId,
      });
    }
  };

  return (
    <Link
      href={articleLink ?? "#"}
      onClick={articleClickHandler}
      className="shopproduct h-full px-0 4xs:pl-0 lg:pr-0 lg:pl-0 "
      aria-labelledby={data?.title}
    >
      <Box
        as="div"
        className="card rounded-tr-[12px] rounded-tl-[12px] overflow-hidden mt-0.5 mb-0 w-full h-full flex-col flex justify-between rounded-lg bg-brandWhite shadow-md"
      >
        <Box
          as="div"
          className="imagemid relative h-[140px] sm:h-[180px] md:h-[160px] lg:h-[190px] xl:h-[158px] overflow-hidden [&_img]:w-full [&_img]:object-cover flex items-center justify-center [&>img]:!h-full"
        >
          {isSearchPage && CheckIfRecordIsPreferred("article", data) && (
            <Box
              as="div"
              className={
                "absolute max-w-[105px] w-full bg-[#a7d6a5] rounded-e-full bottom-[11px] z-[1] left-0"
              }
            >
              <Text as="p" className="text-sm px-[8px]  py-[2px] align-middle">
                Your top picks
              </Text>
            </Box>
          )}
          {data?.videoUrl ? (
            <ImageWrapper
              src={RecipeImage + "/" + data?.videoThumbnail}
              width={342}
              height={158}
              className="mx-auto aspect-ratio"
              alt={data?.title || "Article Image"}
            />
          ) : (
            data?.bannerImage && (
              <ImageWrapper
                src={RecipeImage + "/" + data?.bannerImage}
                width={342}
                height={158}
                className="mx-auto aspect-ratio"
                alt={data?.title || "Article Image"}
              />
            )
          )}
        </Box>

        <Box as="div" className="bottom p-4 gap-2">
          <Box className="flex flex-col justify-between">
            <Box as="div" className="pb-2">
              <Text
                as="h3"
                id="article-title"
                className="text-red-600 text-xl min-h-[60px] font-bold font-sans"
              >
                <Text
                  as="span"
                  className="text-brandBlack font-sans line-clamp-2"
                >
                  {data.title}
                </Text>
              </Text>
            </Box>
            <Box className="w-full">
              {/* <Text as="p" className="text-[14px] font-normal pb-4 text-brandBlack">
                {format(
                  new Date(Number(data?.postedDate) * 1000),
                  "MMMM do, yyyy"
                )}
              </Text> */}
              <Text as="p" className="text-brandBlack py-0">
                <Button variant="outline" asChild>
                  <Link
                    href={articleLink}
                    className="px-6"
                    aria-label={buttonText || "Learn more"}
                  >
                    {/* Learn more */}
                    {buttonText || "Learn more"}
                  </Link>
                </Button>
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Link>
  );
};

export default ArticleCard;
